// Core
import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import { Button, FieldText, SectionCard } from "components/AtomsV2";
import { Icon } from "components/ShellV2";

function AddressInfo({ data, onUpdate, isLoading }) {
  const [original, setOriginal] = useState(data);
  const [address, setAddress] = useState(data.address);

  const canSave = [address].every(Boolean) && !isLoading && !(original.address === address);

  const { t } = useTranslation(["members"]);

  const onUpdateAddressInfoClicked = async () => {
    if (canSave) {
      const newData = {
        address,
      };
      const success = onUpdate(newData, t("single_member.address.updated_ok"));

      if (success) {
        setOriginal({ address });
      }
    }
  };

  return (
    <SectionCard
      id="address"
      icon="location_on"
      title={t("single_member.address.title")}
      action={
        <Button variant="ghost" size="sm" disabled={!canSave} onClick={onUpdateAddressInfoClicked}>
          <Icon name="save" />
          {t("single_member.address.update_button")}
        </Button>
      }
    >
      <FieldText
        label={t("single_member.address.label")}
        value={address}
        onChange={setAddress}
        placeholder={t("single_member.address.placeholder", {
          defaultValue: "Rua, número, localidade",
        })}
      />
    </SectionCard>
  );
}

AddressInfo.defaultProps = {
  isLoading: false,
};

AddressInfo.propTypes = {
  data: PropTypes.shape({
    address: PropTypes.string,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default AddressInfo;
